import Api from "../Api";

export async function getCountries()
{
    return await Api().get("/countries");
}

export async function getLanguages()
{
    return await Api().get("/languages");
}

export async function getTimezones()
{
    return await Api().get("/timezones");
}
